@if (
  {
    violations: violations$ | async
  };
  as STATE
) {
  <article class="brand-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          [title]="brand()?.id ? 'Modifier une marque' : 'Créer une marque'"
          [description]="
            brand()?.id
              ? 'Renseigner le champ ci-dessous pour la modification d\'une marque'
              : 'Renseigner le champ ci-dessous pour la création d\'une marque'
          "
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <div
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
              class="brand-creation-form__file-input__label"
              [ngClass]="{
                'brand-creation-form__file-input__label--hovered': isHovered()
              }"
            >
              <ng-container *ngTemplateOutlet="uploadIcon"></ng-container>

              <div class="">
                <span> Glisser le logo dans la zone ou </span>
                <span
                  (click)="fileInput.click()"
                  class="brand-creation-form__file-input__button"
                >
                  Parcourir les fichiers
                </span>
              </div>
            </div>
            <mat-error
              *ngIf="$any(form.get('logo'))?.getError('httpError') as httpError"
            >
              <strong>{{ httpError }}</strong>
            </mat-error>
          </article>
          <div class="input-group">
            <article>
              <mat-label>Nom de la marque *</mat-label>
              <mat-form-field color="primary">
                <input
                  formControlName="name"
                  matInput
                  placeholder="Nom de la marque"
                />
                <mat-error
                  *ngIf="
                    $any(form.get('name'))?.getError('httpError') as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
            <article>
              <mat-label>Annonceur *</mat-label>
              <ng-select
                [items]="advertiserPagination.items"
                bindLabel="name"
                bindValue="id"
                [loading]="advertiserPagination.loading"
                [typeahead]="advertiserPagination.search$"
                (scrollToEnd)="onAdvertiserScroll()"
                (clear)="advertiserPagination.clear()"
                (search)="advertiserPagination.search($event.term)"
                [virtualScroll]="true"
                [appendTo]="'body'"
                placeholder="Sélectionner l'annconceur"
                formControlName="organizationId"
              >
              </ng-select>
            </article>
          </div>
          <div class="input-group">
            <article>
              <mat-label>Groupe *</mat-label>
              <ng-select
                [items]="groupPagination.items"
                bindLabel="name"
                bindValue="id"
                [loading]="groupPagination.loading"
                [typeahead]="groupPagination.search$"
                (scrollToEnd)="onGroupeScroll()"
                (clear)="onClearGroupe()"
                (search)="groupPagination.search($event.term)"
                [virtualScroll]="true"
                [appendTo]="'body'"
                placeholder="Sélectionner le groupe"
                formControlName="groupId"
              >
              </ng-select>
            </article>
            <article>
              <mat-label>Secteur *</mat-label>
              <ng-select
                [items]="sectorPagination.items"
                bindLabel="name"
                bindValue="id"
                [loading]="sectorPagination.loading"
                [typeahead]="sectorPagination.search$"
                (scrollToEnd)="onSectorScroll()"
                (clear)="onClearSector()"
                (search)="sectorPagination.search($event.term)"
                [virtualScroll]="true"
                [appendTo]="'body'"
                placeholder="Sélectionner le secteur"
                formControlName="sectorId"
              >
              </ng-select>
            </article>
          </div>
          <div class="input-group">
            <article>
              <mat-label>Sous Secteur *</mat-label>
              <ng-select
                [items]="subSectorPagination.items"
                bindLabel="name"
                bindValue="id"
                [loading]="subSectorPagination.loading"
                [typeahead]="subSectorPagination.search$"
                (scrollToEnd)="onSubSectorScroll()"
                (clear)="subSectorPagination.clear()"
                (search)="subSectorPagination.search($event.term)"
                [virtualScroll]="true"
                [appendTo]="'body'"
                placeholder="Sélectionner le sous secteur"
                formControlName="subSectorId"
              >
              </ng-select>
            </article>
            <article>
              <mat-label>Signature</mat-label>
              <mat-form-field color="primary">
                <input
                  formControlName="description"
                  matInput
                  placeholder="Signature"
                />
                <mat-error
                  *ngIf="
                    $any(form.get('description'))?.getError(
                      'httpError'
                    ) as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
          </div>
          <button
            type="submit"
            [attr.loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}

<input
  #fileInput
  [accept]="supportedImageExtensions"
  type="file"
  id="logo"
  hidden
  class="brand-creation-form__file-input"
  (change)="onFileChange($event)"
/>

<ng-template #uploadIcon>
  @if (logo() || logoUrl()) {
    <img [src]="logoUrl()" [width]="74" [height]="74" alt="logo" class="" />
  } @else {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
    >
      <g
        id="Groupe_22409"
        data-name="Groupe 22409"
        transform="translate(-643 -264.646)"
      >
        <g
          id="Upload_Area"
          data-name="Upload Area"
          transform="translate(645 266.646)"
          fill="#f6f4fa"
          stroke="currentColor"
          stroke-width="2"
          stroke-dasharray="10"
        >
          <rect width="70" height="70" rx="5" stroke="none" />
          <rect x="-1" y="-1" width="72" height="72" rx="6" fill="none" />
        </g>
        <g
          id="Icon_akar-image"
          data-name="Icon akar-image"
          transform="translate(666.223 287.869)"
        >
          <path
            id="Tracé_11346"
            data-name="Tracé 11346"
            d="M3,7.311A4.311,4.311,0,0,1,7.311,3H20.244a4.311,4.311,0,0,1,4.311,4.311V20.244a4.311,4.311,0,0,1-4.311,4.311H7.311A4.311,4.311,0,0,1,3,20.244Z"
            transform="translate(0 0)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracé_11347"
            data-name="Tracé 11347"
            d="M14.389,11.694A2.694,2.694,0,1,1,11.694,9,2.694,2.694,0,0,1,14.389,11.694Z"
            transform="translate(-1.689 -1.689)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracé_11348"
            data-name="Tracé 11348"
            d="M18.189,18.655,9,28.763H22.076A4.168,4.168,0,0,0,26.244,24.6v-.143a1.372,1.372,0,0,0-.528-1.067l-4.343-4.737a2.155,2.155,0,0,0-3.184.006Z"
            transform="translate(-1.689 -4.209)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  }
</ng-template>
